import { Link } from "react-router-dom";
import { COMPANY, SERVICES } from "@/lib/site";
import { Phone, Mail, MapPin, Clock, Facebook, Instagram } from "lucide-react";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M19.6 6.4a5.7 5.7 0 0 1-3.4-1.1v9.9a5.7 5.7 0 1 1-5.7-5.7c.2 0 .4 0 .6.1v2.9a2.8 2.8 0 1 0 2.2 2.7V2.5h2.9a5.7 5.7 0 0 0 3.4 5.2v-1.3Z" />
  </svg>
);

export const Footer = () => {
  return (
    <footer className="relative border-t border-white/10 bg-black" data-testid="site-footer">
      <div className="px-6 lg:px-10 pt-24 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <div className="eyebrow mb-4">Hendersonville, Tennessee</div>
            <h2 className="font-display text-5xl md:text-7xl leading-[0.9] tracking-tighter">
              Built to<br /><span className="text-[#FF5722]">Coat.</span> Built to Last.
            </h2>
            <p className="mt-6 max-w-lg text-zinc-400 leading-relaxed">
              Powder coating, media blasting, and chemical stripping for fabricators, manufacturers,
              contractors, and OEM programs across Tennessee and the Southeast.
            </p>
            <Link to="/quote" className="btn-primary mt-8 inline-flex" data-testid="footer-cta-quote">Request a Quote →</Link>

            <div className="mt-8 pt-6 border-t border-white/10">
              <div className="eyebrow mb-3">Follow the Shop</div>
              <div className="flex gap-3" data-testid="footer-socials">
                <a href={COMPANY.social.facebook} target="_blank" rel="noopener noreferrer me" aria-label="Facebook"
                  className="w-11 h-11 border border-white/20 flex items-center justify-center hover:border-[#FF5722] hover:text-[#FF5722] transition-colors" data-testid="social-facebook">
                  <Facebook className="w-4 h-4" />
                </a>
                <a href={COMPANY.social.instagram} target="_blank" rel="noopener noreferrer me" aria-label="Instagram"
                  className="w-11 h-11 border border-white/20 flex items-center justify-center hover:border-[#FF5722] hover:text-[#FF5722] transition-colors" data-testid="social-instagram">
                  <Instagram className="w-4 h-4" />
                </a>
                <a href={COMPANY.social.tiktok} target="_blank" rel="noopener noreferrer me" aria-label="TikTok"
                  className="w-11 h-11 border border-white/20 flex items-center justify-center hover:border-[#FF5722] hover:text-[#FF5722] transition-colors" data-testid="social-tiktok">
                  <TikTokIcon className="w-4 h-4" />
                </a>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="eyebrow mb-4">Services</div>
            <ul className="space-y-2">
              {SERVICES.map(s => (
                <li key={s.slug}>
                  <Link
                    to={`/services/${s.slug}`}
                    className="text-zinc-300 hover:text-[#FF5722] transition-colors text-sm"
                    data-testid={`footer-svc-${s.slug}`}
                  >{s.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="eyebrow mb-4">Contact</div>
            <ul className="space-y-3 text-sm text-zinc-300">
              <li className="flex items-start gap-3"><Phone className="w-4 h-4 mt-0.5 text-[#FF5722]" /><a href={COMPANY.phoneHref} data-testid="footer-phone">{COMPANY.phone}</a></li>
              <li className="flex items-start gap-3"><Mail className="w-4 h-4 mt-0.5 text-[#FF5722]" /><a href={COMPANY.emailHref} data-testid="footer-email">{COMPANY.email}</a></li>
              <li className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-0.5 text-[#FF5722]" /><span>{COMPANY.city}</span></li>
              <li className="flex items-start gap-3"><Clock className="w-4 h-4 mt-0.5 text-[#FF5722]" /><span>{COMPANY.hours}</span></li>
            </ul>

            <div className="eyebrow mt-8 mb-4">Company</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="text-zinc-300 hover:text-white">About</Link></li>
              <li><Link to="/capabilities" className="text-zinc-300 hover:text-white">Capabilities</Link></li>
              <li><Link to="/industries" className="text-zinc-300 hover:text-white">Industries Served</Link></li>
              <li><Link to="/process" className="text-zinc-300 hover:text-white">Our Process</Link></li>
              <li><Link to="/blog" className="text-zinc-300 hover:text-white">Blog</Link></li>
              <li><Link to="/faq" className="text-zinc-300 hover:text-white">FAQ</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs uppercase tracking-widest text-zinc-500">
          <div>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</div>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/terms" className="hover:text-white">Terms</Link>
            <Link to="/cookies" className="hover:text-white">Cookies</Link>
            <Link to="/sitemap" className="hover:text-white">Sitemap</Link>
          </div>
        </div>
      </div>

      <div className="w-full overflow-hidden pointer-events-none select-none">
        <div className="font-display text-[16vw] leading-none tracking-tighter text-white/[0.04] whitespace-nowrap px-6">
          AMERICAN ARMOR COATINGS
        </div>
      </div>
    </footer>
  );
};
